import { createContext, use } from "react";

export type SidebarView = "review" | "toc";

export type SidebarViewValue = {
  view: SidebarView;
  setView: (view: SidebarView) => void;
};

export const SidebarViewContext = createContext<SidebarViewValue | null>(null);

const noSidebarView: SidebarViewValue = { view: "toc", setView: () => {} };

export const useSidebarView = (): SidebarViewValue => use(SidebarViewContext) ?? noSidebarView;
